module.exports = __webpack_public_path__ + "media/images/profile-03-p-500-317a2bc32897082032b7689b48f57ac8.png";